import React, {useState, useEffect} from "react";
import {useAuth} from "react-oidc-context";
import {collection, getDocs} from "firebase/firestore";
import {db} from "../config/firebase-config";

import Nav from "react-bootstrap/Nav";

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Copyright from "./Copyright";
import ModalMangel from "./ModalMangel";

export const Login = (props) => {
  const auth = useAuth();
  const [shake, setShake] = useState(false);
  const [error, setError] = useState(false);
  const [openModalMangel, setOpenModalMangel] = useState(false);
  const [meldeziele, setMeldeziele] = useState([]);
  const [form, setForm] = useState("meldung");

  useEffect(() => {
    if (props.accessDenied) {
      setForm("login");
    }
  }, [props.accessDenied]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    await auth.signinRedirect().catch(() => {
      setShake(true);
      setError(true);
      setTimeout(() => {
        setShake(false);
      }, 500);
      setTimeout(() => {
        setError(false);
      }, 2500);
    });
  };

  // Der Meldeweg sieht Fahrzeuge nur als Meldeziele (Kennzeichen). Geladen
  // wird einmal beim Öffnen, ein Listener lohnt für den kurzen Dialog nicht.
  const handleOpenMeldung = () => {
    setOpenModalMangel(true);
    getDocs(collection(db, "meldeziele"))
      .then((snapshot) => {
        setMeldeziele(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            kennzeichen: doc.data().kennzeichen,
          })),
        );
      })
      .catch((error) => {
        console.error("Meldeziele konnten nicht geladen werden", error);
      });
  };

  const handleCloseMeldung = () => {
    setOpenModalMangel(false);
  };

  const handleChangePage = (page) => {
    if (props.accessDenied && page === "meldung") {
      return;
    }

    setForm(page);
  };

  let mainClasses = "login";
  if (shake) mainClasses += " shake";

  const errorMsg = () => {
    return (
      <div className="loginError">Anmeldung ueber ZITADEL fehlgeschlagen.</div>
    );
  };

  const accessDeniedMsg = () => {
    return (
      <div className="loginError">
        Du hast keine Berechtigung fuer diese App. Melde dich bitte bei
        admin@rettungsdienstbremen.de fuer weitere Fragen.
      </div>
    );
  };

  return (
    <>
      <ModalMangel
        showModal={openModalMangel}
        close={handleCloseMeldung}
        meldeziele={meldeziele}
        kategorien={props.kategorien}
      />
      <Card className={mainClasses}>
        <div>
          <div className="loginHeader">
            <div className="title">
              <h1>Rettungsdienst Bremen</h1>
              <p>Fahrzeugverwaltung</p>
            </div>
            <div className="logo"></div>
          </div>
          <div className="loginBorder">
            <Nav className="loginMenu">
              <Nav.Link href="#" onClick={() => handleChangePage("meldung")}>
                Meldung
              </Nav.Link>
              <Nav.Link href="#" onClick={() => handleChangePage("login")}>
                Login
              </Nav.Link>
            </Nav>
          </div>
          {form === "meldung" ? (
            <div className="loginForm">
              <Button
                onClick={() => {
                  handleOpenMeldung();
                }}
                variant="warning"
                style={{width: "100%", marginTop: "15px"}}
              >
                Mangel an Fahrzeug melden
              </Button>
            </div>
          ) : (
            <div className="loginForm">
              <Form onSubmit={handleSubmit}>
                {props.accessDenied ? accessDeniedMsg() : undefined}
                {error ? errorMsg() : undefined}
                <Button
                  type="submit"
                  variant="primary"
                  style={{width: "100%", marginTop: "15px"}}
                >
                  Jetzt anmelden
                </Button>
              </Form>
            </div>
          )}
          <div className="loginHinweis">
            Bei Problemen wende dich bitte an{" "}
            <a href="mailto:admin@rettungsdienstbremen.de">
              admin@rettungsdienstbremen.de
            </a>
          </div>
        </div>
      </Card>{" "}
      <Copyright />
    </>
  );
};

export default Login;
